<template>
  <tk-container class="user2" :status="status">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      个人主页
    </tkui-header>
    <tk-flex class="item" middle between>
      <h2 class="name">头像</h2>
      <tk-flex>
        <tk-image @click.native="changeAvatar" v-if="user.avatar" :src="user.avatar" width="60" height="60" style="border-radius: 50%"></tk-image>
        <tk-icon v-if="!user.avatar" @click.native="changeAvatar" style="height: 14px;color: #666666;">return_copy</tk-icon>
      </tk-flex>
    </tk-flex>
    <tk-flex class="item" middle between>
      <h2 class="name">昵称</h2>
      <div>
        <p v-if="user.username">{{user.username}}</p>
        <tk-icon v-else style="height: 14px;color: #666666;">return_copy</tk-icon>
      </div>
    </tk-flex>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        avatar: '',
        status: false
      }
    },
    computed: {
      user () {
        return this.$store.state.user || {}
      }
    },
    methods: {
      back () {
        this.$back()
      },
      async changeAvatar () {
        try {
          this.status = 'waiting'
          let img = await this.$tkFile.pick()
          let res = await this.$tkParse.post('/files', img.buffer)
          await this.$tkParse.put(`/users/${this.user.objectId}`, {
            'avatar': res.data.url
          })
          this.$store.commit('changeUser', {
            'key': 'avatar',
            'val': res.data.url
          })
          this.status = false
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('上传头像失败')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .user2{
    .item{
      padding: 20px 15px;
      margin-bottom: 2px;
      background: #ffffff;
      .name{
        color: #333333;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/user/user2.vue